/**
 * Binding avec les différent état possible pour une commande
 */
export default {
  draft: 'Brouillon',
  picking_required: 'À picker',
  check_before_requiring_picking: 'Validation en cours avant traitement',
  address_check_in_progress: 'Adresse en cours de validation',
  address_to_be_corrected: 'Adresse à corriger',
  prepicker: 'En cours de prépicking',
  picker: 'En cours de picking',
  out_of_stock: 'En rupture de stock',
  picking_paused: 'Picking en pause',
  waiting_for_courier: 'En attente de coursier',
  courier: 'Ramassé',
  packing_required: 'À emballer',
  packer: "En cours d'emballage",
  packing_paused: 'Emballage en pause',
  packing_finished: 'Emballage terminé',
  ready: 'Prêt à être expédié',
  given_to_carrier: 'Donné au transporteur',
  scanned_by_carrier: 'En transit',
  delivered: 'Livré',
  blocked: 'Bloqué',
  delivery_failed: 'Livraison échouée',
  returned: 'Retourné',
  destroyed: 'Détruit',
  cancelled: 'Annulé',
  lost: 'Perdu',
  return_waiting: 'Retour en attente de dépôt',
  non_prepared: 'Non préparé',
  prepared: 'Préparé',
  delivery_in_progress: 'Livraison en cours',
  done: 'Échange effectué'
};
